import { baseURLAdmin, commonHeaderAdmin } from "api/constants";

export async function getLabelingHistoryAPI(params = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (params.sourceId) queryParams.append("sourceId", params.sourceId);
    const queryString = queryParams.toString();
    const url = `${baseURLAdmin}/labeling-history${
      queryString ? `?${queryString}` : ""
    }`;
    const res = await fetch(url, {
      method: "GET",
      ...commonHeaderAdmin,
    });
    return await res.json();
  } catch (error) {
    console.log(error, "error");
    return { error: true, ...error };
  }
}
